import { Outlet } from '@tanstack/react-router';
import { ReactNode, Suspense } from 'react';

import { PageLoader } from '../loading/page-loader';
import { SubNavigation, SubNavigationItem } from './sub-navigation';

export interface PageProps {
  children?: ReactNode;
  links?: SubNavigationItem[];
  /** Suspense fallback override, PageLoader will be used by default */
  suspenseFallback?: ReactNode;
  title: string;
}

export function Page({ children, links, suspenseFallback, title }: PageProps) {
  return (
    <div className="relative grid h-full w-full grid-rows-[auto_1fr] overflow-hidden">
      <SubNavigation links={links} title={title} />
      <Suspense fallback={suspenseFallback || <PageLoader />}>
        <div className="h-full w-full overflow-auto p-4">{children ? children : <Outlet />}</div>
      </Suspense>
    </div>
  );
}
